export default "__VITE_ASSET__BAGLd334__"